<template>
  <v-app style="background: #daffdb">
    <v-main>
      <router-view />
    </v-main>
    <!-- toast -->
    <vtoast ref="vtoast" />
  </v-app>
</template>

<script>
import vtoast from "@/components/common/Snackbar.vue";
export default {
  name: "App",
  components: {
    vtoast,
  },
  data: () => ({
    //
  }),
  mounted() {
    this.$root.vtoast = this.$refs.vtoast
    this.checkEmailVerification()
  },
  methods: {
    checkEmailVerification() {
      const params = new URLSearchParams(window.location.search)

      if (params.get('email_verified') === '1') {
        this.$root.vtoast.showSuccess('メールアドレスが認証されました')
        // Remove query parameter from URL
        window.history.replaceState({}, document.title, window.location.pathname)
      } else if (params.get('already_verified') === '1') {
        this.$root.vtoast.showSuccess('このメールアドレスは既に認証済みです')
        // Remove query parameter from URL
        window.history.replaceState({}, document.title, window.location.pathname)
      }
    }
  }
};
</script>

